
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppButton, AppTable } from '@/components';
import { useDuplicateCycleDeck } from '@/modules/duplicate/cycle/item/model/deck';
import { ROUTE_NAME_DUPLICATE } from '@/modules/duplicate/router';
import { TableColumn, TableColumnType } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_DUPLICATE.CYCLE.DECK,
    components: { AppButton, AppTable, AppCard },
    setup() {
        const { list, total, fetchList } = useDuplicateCycleDeck();

        const columns: TableColumn[] = [
            { type: TableColumnType.Text, label: 'GameID', key: 'gameId' },
            { type: TableColumnType.Text, label: 'Round', key: 'round' },
            { type: TableColumnType.Html, label: 'Decks', htmlHandler: (row: any) => row.decks.join('<br>') }
        ];

        onMounted(fetchList);

        return { columns, list, total, fetchList, ROUTE_NAME_DUPLICATE };
    }
});
